import { render, staticRenderFns } from "./CardNotFound.vue?vue&type=template&id=6448b918&"
import script from "./CardNotFound.vue?vue&type=script&lang=js&"
export * from "./CardNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports